import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { faCircle, faVoicemail } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { off, onValue } from "firebase/database";
import { useEffect, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useAtedimento } from "../../../../Context/Atendimento";
import { useUserInfor } from "../../../../Context/User";
import { IChat, IEquipeOffline } from "../../../../Interfaces/HelpDesk/Equipes/Atendimento/AtendimentoInterfaces";
import {
    IEquipeFirebase,
    IUsuarioFirebase,
} from "../../../../Interfaces/HelpDesk/Equipes/EquipeInterface";
import {
    getChatsRef,
    getOnlineRef,
} from "../../../../Services/Config/ConfigFirebase";

interface IEquipeUsuarioFirebase extends IEquipeFirebase {
    lstUsuarios: Array<IUsuarioFirebase>;
}

export default function AtendentesOnline() {
    const [lstEquipes, setLstEquipes] =
        useState<Array<IEquipeUsuarioFirebase>>();
    const [lstEquipesOffline, setLstEquipesOffline] =
        useState<Array<IEquipeOffline>>();
    const [chats, setChats] = useState<Array<IChat>>();

    const { equipe } = useAtedimento().HELP_DESK;
    const { OrgInfor } = useUserInfor();


    useEffect(() => {
        if (equipe?.NR_TELEFONE) {
            const equipesRef = getOnlineRef(OrgInfor.ID_ORGANIZACAO);
            onValue(equipesRef, (snap) => {
                const equipesOn: Array<IEquipeUsuarioFirebase> = [];
                snap.forEach((equipeSnap) => {
                    const lstUsuarios = equipeSnap.val().USUARIOS
                        ? Object.entries<IUsuarioFirebase>(
                              equipeSnap.val().USUARIOS
                          ).map((entry) => entry[1])
                        : [];
                    if (lstUsuarios.length > 0)
                        equipesOn.push({
                            ...equipeSnap.val(),
                            lstUsuarios: lstUsuarios,
                        });
                });
                setLstEquipes(equipesOn);
            });
            const chatsRef = getChatsRef(
                OrgInfor.ID_ORGANIZACAO,
                equipe?.NR_TELEFONE
            );
            onValue(chatsRef, (snap) => {
                const chats: Array<IChat> = [];
                snap.forEach((childSnap) => {
                    chats.push(childSnap.val());
                });

                setChats(chats);
               
            });
        }

        return function cleanup() {
            if (equipe?.NR_TELEFONE) {
                off(getOnlineRef(OrgInfor.ID_ORGANIZACAO));
                off(getChatsRef(OrgInfor.ID_ORGANIZACAO, equipe?.NR_TELEFONE));
            }
        };
    }, [OrgInfor.ID_ORGANIZACAO, equipe?.NR_TELEFONE]);


    useEffect(() =>{
        let lstResponse:Array<IEquipeOffline> = [];

        chats?.forEach(chat =>{
            
            let existUser = lstResponse.find(ft => ft.ID_EQUIPE === chat.IDEquipe && ft.ID_USUARIO === chat.IdUsuario);
           
            let existEquipeOnline = lstEquipes?.find(x => x.ID_EQUIPE === chat.IDEquipe && x.DS_EQUIPE === chat.DsEquipe);

            let UserOnline = existEquipeOnline?.lstUsuarios.filter(s => s.ID_USUARIO === chat.IdUsuario);

            if(UserOnline?.length === 0){
                if(existUser && existEquipeOnline){
                    lstResponse = lstResponse.filter(chat => chat !== existUser);
                    existUser.NR_TOTAL_ATENDIMENTO += 1
                    lstResponse.push(existUser);
                }else if(existEquipeOnline){
                    lstResponse.push({
                        ID_EQUIPE: chat.IDEquipe,
                        DS_EQUIPE: chat.DsEquipe || "",
                        ID_USUARIO: chat.IdUsuario,
                        DS_USUARIO: chat.NomeUsuario,
                        NR_TOTAL_ATENDIMENTO: 1
                    });
                }
            }
        })
        setLstEquipesOffline(lstResponse);

    }, [chats, lstEquipes])

    return (
        <div>
            <h4 className="font-weight-bolder">Atendentes Online</h4>
            <div
                className="accordion accordion-light accordion-light-borderless accordion-svg-toggle"
                id="accordionEquipesOnline"
            >
                {lstEquipes && lstEquipes.length > 0 ? (
                    lstEquipes.map((equipe) => {
                        const online = equipe.lstUsuarios.length;
                        const [aguardando, emAtendimento] = chats
                            ?.filter(
                                (chat) => chat.IDEquipe === equipe.ID_EQUIPE
                            )
                            .reduce(
                                (count, chat) => {
                                    if (
                                        chat.IDEquipe === equipe.ID_EQUIPE &&
                                        chat.IdUsuario === 0
                                    )
                                        count[0]++;
                                    else count[1]++;
                                    return count;
                                },
                                [0, 0]
                            ) || [0, 0];

                        return (
                            <div className="card" key={equipe.ID_EQUIPE}>
                                <div
                                    className="card-header"
                                    id={"heading" + equipe.ID_EQUIPE}
                                >
                                    <div
                                        className="card-title collapsed"
                                        data-toggle="collapse"
                                        data-target={
                                            "#collapseEquipe" + equipe.ID_EQUIPE
                                        }
                                    >
                                        <span className="svg-icon svg-icon-primary">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                xmlnsXlink="http://www.w3.org/1999/xlink"
                                                width="24px"
                                                height="24px"
                                                viewBox="0 0 24 24"
                                                version="1.1"
                                            >
                                                <g
                                                    stroke="none"
                                                    strokeWidth="1"
                                                    fill="none"
                                                    fillRule="evenodd"
                                                >
                                                    <polygon points="0 0 24 0 24 24 0 24"></polygon>
                                                    <path
                                                        d="M12.2928955,6.70710318 C11.9023712,6.31657888 11.9023712,5.68341391 12.2928955,5.29288961 C12.6834198,4.90236532 13.3165848,4.90236532 13.7071091,5.29288961 L19.7071091,11.2928896 C20.085688,11.6714686 20.0989336,12.281055 19.7371564,12.675721 L14.2371564,18.675721 C13.863964,19.08284 13.2313966,19.1103429 12.8242777,18.7371505 C12.4171587,18.3639581 12.3896557,17.7313908 12.7628481,17.3242718 L17.6158645,12.0300721 L12.2928955,6.70710318 Z"
                                                        fill="#000000"
                                                        fillRule="nonzero"
                                                    ></path>
                                                    <path
                                                        d="M3.70710678,15.7071068 C3.31658249,16.0976311 2.68341751,16.0976311 2.29289322,15.7071068 C1.90236893,15.3165825 1.90236893,14.6834175 2.29289322,14.2928932 L8.29289322,8.29289322 C8.67147216,7.91431428 9.28105859,7.90106866 9.67572463,8.26284586 L15.6757246,13.7628459 C16.0828436,14.1360383 16.1103465,14.7686056 15.7371541,15.1757246 C15.3639617,15.5828436 14.7313944,15.6103465 14.3242754,15.2371541 L9.03007575,10.3841378 L3.70710678,15.7071068 Z"
                                                        fill="#000000"
                                                        fillRule="nonzero"
                                                        opacity="0.3"
                                                        transform="translate(9.000003, 11.999999) rotate(-270.000000) translate(-9.000003, -11.999999) "
                                                    ></path>
                                                </g>
                                            </svg>
                                        </span>
                                        <div className="card-label w-100 d-flex justify-content-between align-items-center pl-4">
                                            <span>{equipe.DS_EQUIPE}</span>
                                            <span className="d-flex">
                                                <OverlayTrigger
                                                    overlay={
                                                        <Tooltip id="tooltip-disabled">
                                                            Atendentes Online
                                                        </Tooltip>
                                                    }
                                                >
                                                    <span className="d-flex align-items-center mr-4">
                                                        <FontAwesomeIcon
                                                            icon={faCircle}
                                                            className="text-success mr-1"
                                                        />{" "}
                                                        {online}
                                                    </span>
                                                </OverlayTrigger>
                                                <OverlayTrigger
                                                    overlay={
                                                        <Tooltip id="tooltip-disabled">
                                                            Clientes Aguardando
                                                        </Tooltip>
                                                    }
                                                >
                                                    <span className="d-flex align-items-center mr-4">
                                                        <FontAwesomeIcon
                                                            icon={faVoicemail}
                                                            className="text-warning mr-1"
                                                        />{" "}
                                                        {aguardando}
                                                    </span>
                                                </OverlayTrigger>
                                                <OverlayTrigger
                                                    overlay={
                                                        <Tooltip id="tooltip-disabled">
                                                            Clientes em
                                                            Atendimento
                                                        </Tooltip>
                                                    }
                                                >
                                                    <span className="d-flex align-items-center">
                                                        <FontAwesomeIcon
                                                            icon={faWhatsapp}
                                                            className="text-info mr-1"
                                                        />{" "}
                                                        {emAtendimento}
                                                    </span>
                                                </OverlayTrigger>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    id={"collapseEquipe" + equipe.ID_EQUIPE}
                                    className="collapse"
                                    data-parent="#accordionEquipesOnline"
                                >
                                    <div className="card-body pl-12">
                                        {equipe.lstUsuarios.map((usuario) => {
                                            const atendendo =
                                                chats?.reduce((count, chat) => {
                                                    if (
                                                        chat.IdUsuario ===
                                                        usuario.ID_USUARIO
                                                    )
                                                        count++;
                                                    return count;
                                                }, 0) || 0;

                                            return (
                                                <div
                                                    className="d-flex justify-content-between  align-items-center py-2"
                                                    key={usuario.ID_USUARIO}
                                                >
                                                    <div className="d-flex align-items-center">
                                                        <span className="symbol symbol-35">
                                                            <span className="symbol-label font-size-h5 bg-success text-white font-weight-bold text-uppercase">
                                                                {usuario.DS_USUARIO.substring(
                                                                    0,
                                                                    1
                                                                )}
                                                            </span>
                                                        </span>
                                                        <span className="px-3">
                                                            {usuario.DS_USUARIO}
                                                        </span>
                                                        <OverlayTrigger
                                                            overlay={
                                                                <Tooltip id="tooltip-disabled">
                                                                    Atendendo
                                                                </Tooltip>
                                                            }
                                                        >
                                                            <span className="d-flex align-items-center mr-4">
                                                                <FontAwesomeIcon
                                                                    icon={
                                                                        faWhatsapp
                                                                    }
                                                                    className="text-success mr-1"
                                                                />{" "}
                                                                {atendendo}
                                                            </span>
                                                        </OverlayTrigger>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                        {lstEquipesOffline?.filter(x => x.ID_EQUIPE === equipe.ID_EQUIPE).map((usuario) => {
                                            const atendendo =
                                                chats?.reduce((count, chat) => {
                                                    if (
                                                        chat.IdUsuario ===
                                                        usuario.ID_USUARIO
                                                    )
                                                        count++;
                                                    return count;
                                                }, 0) || 0;

                                            return (
                                                <div
                                                    className="d-flex justify-content-between  align-items-center py-2"
                                                    key={usuario.ID_USUARIO}
                                                >
                                                    <div className="d-flex align-items-center">
                                                        <span className="symbol symbol-35">
                                                            <span className="symbol-label font-size-h5 bg-danger text-white font-weight-bold text-uppercase">
                                                                {usuario.DS_USUARIO.substring(
                                                                    0,
                                                                    1
                                                                )}
                                                            </span>
                                                        </span>
                                                        <span className="px-3">
                                                            {usuario.DS_USUARIO}
                                                        </span>
                                                        <OverlayTrigger
                                                            overlay={
                                                                <Tooltip id="tooltip-disabled">
                                                                    Atendendo
                                                                </Tooltip>
                                                            }
                                                        >
                                                            <span className="d-flex align-items-center mr-4">
                                                                <FontAwesomeIcon
                                                                    icon={
                                                                        faWhatsapp
                                                                    }
                                                                    className="text-success mr-1"
                                                                />{" "}
                                                                {atendendo}
                                                            </span>
                                                        </OverlayTrigger>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>
                        );
                    })
                ) : (
                    <div className="text-muted">Nenhum Atendente Online</div>
                )}
            </div>
        </div>
    );
}
